import { Serializers } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const threadsSortFields = [
  "createdAt",
  "deadline",
  "referenceNumber",
  "invoiceTotal",
  "invoiceNumber",
  "invoiceIssuer",
  "title",
  "approvedAt",
  "invoiceReceivedDate",
  "invoiceIssueDate",
  "decreeNumber",
  "invitedAt",
  "dueDate",
] as const;

export const threadStatuses = ["open", "closed", "approved"] as const;
export type ThreadStatus = (typeof threadStatuses)[number];

export const invoiceThreadFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  sort: Serializers.sortFilter(threadsSortFields),
  searchText: Serializers.string,
  status: Serializers.stringOneOf(...threadStatuses).array(),
  signedBy: Serializers.string.array(),
  budgetUuid: uuidSerializer.array(),
  isDigital: Serializers.booleanFieldFilter,
  isReceived: Serializers.booleanFieldFilter,
  isPosted: Serializers.booleanFieldFilter,
  participant: Serializers.string.array(),
  isRead: Serializers.booleanFieldFilter,
  isOverdue: Serializers.booleanFieldFilter,
  isMine: Serializers.booleanFieldFilter,
  issuer: Serializers.string,
  tags: Serializers.string.array(),
  groupFilter: Serializers.stringOneOf("mine", "all"),
}).partial();
